<script>
import axios from 'axios'
export default {
  computed: {
    clientUrl: function () {
      return `/api/client/${this.id}`;
    }
  },
  methods: {
    blacklistClient: function (e) {
      this.$emit('update:blacklisted', e.target.checked);
      axios.put(this.clientUrl, {
        client_data: {
          blacklisted: e.target.checked
        }
      });
    },
    toggleStatusPing: function (e) {
      this.$emit('update:runs_status_ping', e.target.checked);
      axios.put(this.clientUrl, {
        action: 'update',
        client_data: {
          run_status_ping: e.target.checked
        }
      });
    },
  },
  data() {
    return {
      client_runs_status_ping: this.runs_status_ping,
      client_blacklisted: this.blacklisted,
    }
  },
  props: {
    blacklisted: Boolean,
    connection_events: Array,
    id: String,
    ini_version: String,
    runs_status_ping: Boolean,
    total_pings: Number
  }
};
</script>
<template>
  <tr>
    <td>
      <router-link v-bind:to="'/clients/' + id">{{ id }}</router-link></td>
    <td>{{ ini_version }}</td>
    <td>{{ total_pings }}</td>
    <td>
      <div class="switch">
        <label>Off
          <input v-bind:id="'status-check-' + id" type="checkbox" v-on:change="toggleStatusPing" v-model="client_runs_status_ping">
          <span class="lever"></span>On
        </label>
      </div>
    </td>
    <td>
      <div class="switch">
        <label>Off
          <input v-bind:id="'blacklist-check-' + id" type="checkbox" v-on:change="blacklistClient" v-model="client_blacklisted">
          <span class="lever"></span>On
        </label>
      </div>
    </td>
    <td>
      <button class="waves-effect waves-light btn red"
        v-on:click="$emit('remove', id)" type="button">Remove</button>
    </td>
  </tr>
</template>
